'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import IconButton, { iconButtonClasses, } from '@enlighten/design-system/dist/IconButton';
import { useTheme } from '@enlighten/design-system/dist/styles';
import Typography from '@enlighten/design-system/dist/Typography';
import useMediaQuery from '@enlighten/design-system/dist/useMediaQuery';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import NextButtonImage from '../../assets/images/king/slide-next-button.png';
import PrevButtonImage from '../../assets/images/king/slide-prev-button.png';
const list = [
    {
        src: 'wIKe1ygg3gY',
        thumbnail: 'https://img.youtube.com/vi/wIKe1ygg3gY/0.jpg',
        playTime: '14:39',
    },
    {
        src: 'Bdhzr9kCUKM',
        thumbnail: 'https://img.youtube.com/vi/Bdhzr9kCUKM/0.jpg',
        playTime: '15:04',
    },
    {
        src: '9vVdGL29Fbo',
        thumbnail: 'https://img.youtube.com/vi/9vVdGL29Fbo/0.jpg',
        playTime: '15:00',
    },
];
// @ts-ignore
const SliderComponent = !!Slider.default ? Slider.default : Slider;
export default function KingSection6({ onClick }) {
    const [slideIndex, setSlideIndex] = useState(0);
    const carouselRef = useRef(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.slickGoTo(slideIndex);
        }
    }, [isMobile, slideIndex]);
    useEffect(() => {
        if (slideIndex === 2 && !isMobile) {
            setSlideIndex(1);
        }
    }, [slideIndex, isMobile]);
    return (_jsxs(Grid, { container: true, direction: "column", alignItems: "center", width: "100%", maxWidth: { xs: '100%', md: 1400 }, marginX: "auto", marginTop: { xs: 15, md: 25 }, children: [_jsx(Typography, { fontSize: { xs: 24, md: 40 }, fontWeight: 700, textAlign: "center", lineHeight: 1.35, marginY: { xs: 3, md: 5 }, children: '태양광 이제는 발전왕 하나로\n손쉽게 시작하세요.' }), _jsx(Grid, { container: true, width: "100%", maxWidth: 1400, overflow: isMobile ? 'hidden' : undefined, sx: {
                    '.slick-slider': {
                        width: '100%',
                        height: 'inherit',
                        '.slick-track': {
                            display: 'flex',
                            paddingBottom: '30px',
                        },
                    },
                    '.slick-slide': {
                        maxHeight: 400,
                        aspectRatio: '715 / 400',
                        paddingX: 3,
                        '> div': {
                            height: '100%',
                        },
                    },
                    '.slick-arrow': {
                        display: 'none !important',
                    },
                }, children: _jsx(SliderComponent, { ref: carouselRef, infinite: false, swipe: false, slidesToShow: isMobile ? 1 : 2, prevArrow: null, nextArrow: null, children: list.map((item, i) => (_jsx(Button, { variant: "text", onClick: () => {
                            onClick && onClick(item);
                        }, sx: {
                            background: `url(${item.thumbnail}) no-repeat center / cover`,
                            height: '100%',
                            borderRadius: 5,
                            padding: 0,
                            boxShadow: '0 5px 15px #00000033',
                        } }, i))) }) }), _jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", sx: {
                    img: {
                        width: { xs: '40px', md: '48px' },
                        height: 'auto',
                    },
                    [`.${iconButtonClasses.root}`]: {
                        padding: 1,
                        '&.Mui-disabled': {
                            opacity: 0.5,
                        },
                    },
                }, children: [_jsx(IconButton, { disabled: slideIndex === 0, onClick: () => {
                            if (slideIndex > 0) {
                                setSlideIndex((state) => state - 1);
                            }
                        }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                            process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: PrevButtonImage, alt: "prev" })) : (_jsx("img", { src: PrevButtonImage, alt: "prev" })) }), _jsx(IconButton, { disabled: slideIndex === (isMobile ? list.length - 1 : list.length - 2), onClick: () => {
                            if (slideIndex < (isMobile ? list.length : list.length - 1)) {
                                setSlideIndex((state) => state + 1);
                            }
                        }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                            process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: NextButtonImage, alt: "next" })) : (_jsx("img", { src: NextButtonImage, alt: "next" })) })] })] }));
}
